import { useState } from 'react';

/*
 * useLauncherContext — true when the app should present the Jitterbug launcher
 * as the landing/home, false when it should use the desktop rail.
 *
 * Trigger (evaluated once at first mount; NOT subscribed to resize, to avoid a
 * surprise reflow mid-session):
 *   - narrow viewport (<=768px)                     -> launcher, OR
 *   - installed PWA on a touch device
 *     (display-mode standalone AND pointer coarse)  -> launcher.
 *
 * A desktop PWA install (standalone but fine pointer) deliberately stays on the
 * rail — the launcher exists for touch + small screens, not for "is it installed."
 */
export function useLauncherContext() {
  const [isLauncherContext] = useState(() => {
    if (typeof window === 'undefined') return false;
    const match = (q) => window.matchMedia(q).matches;
    const isNarrow = match('(max-width: 768px)');
    const isStandalone =
      match('(display-mode: standalone)') || window.navigator.standalone === true;
    const isCoarsePointer = match('(pointer: coarse)');
    return isNarrow || (isStandalone && isCoarsePointer);
  });

  return isLauncherContext;
}
